import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { LegaleIncaricato } from '../../../models/legale-incaricato';

@Component({
    selector: '[legale_anagrafica_view]',
  templateUrl: 'legale-anagrafica-view.component.html',
})

export class LegaleAnagraficaViewComponent {
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Input()
  legaleIncaricato: LegaleIncaricato;
}
